<template>
    <div v-show="(isMobile && !modals.fullscreen && modals.sideMenuBurger)" 
        class="side-menu-burger"
        :class="{ mobile: isMobile }">
        <div class="scroll-menu ">
            <div class="menu-item" 
                :class="{ active: modalMenu.market }" 
                @click="openWidget('market')">
                    <i class="material-symbols-outlined">lists</i>
                    <span class="label__largeprominent">{{ tokens.sideMenu.marketWatch }}</span>
                    <i class="material-symbols-outlined toggle-btn">add</i>
            </div>
            <div class="menu-item" 
                :class="{ active: modalMenu.orders }" 
                @click="openWidget('orders')">
                    <i class="material-symbols-outlined">orders</i>
                    <span class="label__largeprominent">{{ tokens.sideMenu.activeOrders }}</span>
                    <i class="material-symbols-outlined toggle-btn">add</i>
            </div>
            <div class="menu-item" 
                :class="{ active: modalMenu.history }" 
                @click="openWidget('history')">
                    <i class="material-symbols-outlined">history</i>
                    <span class="label__largeprominent">{{ tokens.sideMenu.tradingHistory }}</span>
                    <i class="material-symbols-outlined toggle-btn">add</i>
            </div>
            <!-- :class="{ active: modalMenu.calendar }"  -->
            <div v-if="user.enable_autotrader && !hideTradingBot"
                class="menu-item" 
                @click="showAutoTraderModal()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M15.5 13.5C13.9722 13.5 12.6736 12.9653 11.6042 11.8958C10.5347 10.8264 10 9.52778 10 8C10 6.47222 10.5347 5.17361 11.6042 4.10417C12.6736 3.03472 13.9722 2.5 15.5 2.5C17.0278 2.5 18.3264 3.03472 19.3958 4.10417C20.4653 5.17361 21 6.47222 21 8C21 9.52778 20.4653 10.8264 19.3958 11.8958C18.3264 12.9653 17.0278 13.5 15.5 13.5ZM13.6208 10.75H12.5208L14.9042 4.33333H16.05L18.4792 10.75H17.3792L16.7833 9.1H14.2167L13.6208 10.75ZM14.5375 8.18333L15.4542 5.525H15.5458L16.4625 8.18333H14.5375Z"
                                fill="var(--System-OnSurface)"/>
                        <path
                            d="M15 15.4367C15.3243 15.4789 15.6576 15.5 16 15.5C16.1762 15.5 16.35 15.4944 16.5214 15.4832L16.55 19.5H15V21.5H13V19.5H11.5V13.8816C11.9685 14.28 12.4685 14.6048 13 14.8561V17.5H15V15.4367Z"
                            fill="var(--System-OnSurface)"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M7 21.5V16.5H9V9.5H7V5.5H5V9.5H3V16.5H5V21.5H7ZM7 14.5H5V11.5H7V14.5Z" fill="var(--System-OnSurface)"/>
                    </svg>
                    <span class="label__largeprominent">
                        {{ autoTraderToAiTrader ? 
                            tokens.autoTrader.titleAi : 
                            (customTokens.autoTrader.title[brand] || tokens.autoTrader.title) }}
                    </span>
            </div>
            <div class="menu-item" 
                :class="{ active: modalMenu.calendar }" 
                @click="openWidget('calendar')">
                    <i class="material-symbols-outlined">calendar_today</i>
                    <span class="label__largeprominent">{{ tokens.sideMenu.economicCalendar }}</span>
                    <i class="material-symbols-outlined toggle-btn">add</i>
            </div>
            <div class="menu-item" 
                :class="{ active: modalMenu.news }" 
                @click="openWidget('news')">
                    <i class="material-symbols-outlined">full_coverage</i>
                    <span class="label__largeprominent">{{ tokens.sideMenu.marketNews }}</span>
                    <i class="material-symbols-outlined toggle-btn">add</i>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MODAL, MODAL_MENU } from "@/store/mutations.type"
import { isMobile } from '@/common/helpers'
import { HIDE_TRADING_BOT, AUTOTRADER_TO_AI_TRADER, BRAND } from "@/common/config"

export default {
    name: "SideMenuBurger",
    data() {
        return {
            isMobile: isMobile(),
            hideTradingBot: HIDE_TRADING_BOT,
            autoTraderToAiTrader: AUTOTRADER_TO_AI_TRADER,
            brand: BRAND
        }
    },
    methods: {
        openWidget(widget) {
            let n = JSON.parse(JSON.stringify(this.modalMenu))

            for (let i in n) {
                n[i] = false
            }

            n[widget] = !n[widget]

            this.$store.commit(MODAL_MENU, n)

            let hideMenuModal = true

            for (let i in n) {
                if (n[i]) {
                    hideMenuModal = false
                    break
                }
            }

            if (hideMenuModal) {
                setTimeout(() => {
                    this.$store.commit(MODAL, {
                        menuModal: true,
                        sideMenuBurger: false
                    })
                }, 0);
            }

            if (n[widget] && !this.modals.menu) {
                this.$store.commit(MODAL, {
                    menu: true
                })
            }
        },
        showAutoTraderModal() {
            this.$store.commit(MODAL, {
                autoTrader: true
            })
        }
    },
    computed: {
        ...mapGetters(['tokens', 'modals', 'modalMenu','user','customTokens']),
    }
}
</script>

<style scoped>
.side-menu-burger {
    position: absolute;
    top: -7px;
    left: 8px;
    background: var(--System-Surface2);
    width: 200px;
    border-radius: 4px;
    z-index: 8;
    padding: 8px 0;
    color: var(--System-OnSurface)
}

.menu-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    padding: 12px 10px;
    position: relative;
}

.menu-item.active {
    background: var(--Statelayers-primary-opacity16);
}
.menu-item:active {
    background: var(--Statelayers-onsurface-opacity08);
}

.toggle-btn {
    padding: 0;
    border-radius: 100%;
    border: 2px solid var(--System-Surface);
    background: var(--System-OnSurface);
    position: absolute;
    top: 23px;
    left: 23px;
    font-size: 11px;
    font-weight: 500;
    color: var(--System-Surface1);
    cursor: pointer;
    transition: color ease-in-out 0.3s, background ease-in-out 0.3s, opacity ease-in-out 0.3s;
}
</style>
